var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnlinemarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "online-marketing_5343759 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5999 39.8447C16.1083 39.8428 15.6258 39.711 15.2015 39.4628C14.7771 39.2145 14.4259 38.8586 14.1832 38.431L11.8632 34.5281C11.83 34.4705 11.7826 34.4225 11.7254 34.3887C11.6683 34.3548 11.6034 34.3362 11.537 34.3347H5.18115C4.82094 34.3379 4.46363 34.2701 4.12962 34.1352C3.79561 34.0003 3.49145 33.8009 3.2345 33.5485C2.97755 33.296 2.77285 32.9954 2.63207 32.6638C2.4913 32.3323 2.41722 31.9762 2.41406 31.616V16.5118C2.41722 16.1516 2.4913 15.7956 2.63207 15.464C2.77285 15.1324 2.97755 14.8318 3.2345 14.5793C3.49145 14.3269 3.79561 14.1275 4.12962 13.9926C4.46363 13.8577 4.82094 13.7899 5.18115 13.7931H28.647C29.0072 13.7899 29.3645 13.8577 29.6985 13.9926C30.0325 14.1275 30.3367 14.3269 30.5936 14.5793C30.8506 14.8318 31.0553 15.1324 31.1961 15.464C31.3368 15.7956 31.4109 16.1516 31.4141 16.5118V31.616C31.4109 31.9762 31.3368 32.3323 31.1961 32.6638C31.0553 32.9954 30.8506 33.296 30.5936 33.5485C30.3367 33.8009 30.0325 34.0003 29.6985 34.1352C29.3645 34.2701 29.0072 34.3379 28.647 34.3347H21.6386C21.5795 34.334 21.5213 34.3494 21.4702 34.3792C21.4191 34.409 21.3771 34.4521 21.3486 34.5039L19.0407 38.431C18.7961 38.8622 18.441 39.2204 18.012 39.4689C17.5831 39.7173 17.0956 39.8471 16.5999 39.8447ZM5.18115 16.2097C5.13828 16.2064 5.09518 16.2117 5.05433 16.2251C5.01349 16.2385 4.9757 16.2599 4.94313 16.2879C4.91057 16.316 4.88387 16.3502 4.86458 16.3887C4.84529 16.4271 4.83379 16.4689 4.83073 16.5118V31.616C4.83379 31.6589 4.84529 31.7007 4.86458 31.7392C4.88387 31.7776 4.91057 31.8118 4.94313 31.8399C4.9757 31.868 5.01349 31.8893 5.05433 31.9027C5.09518 31.9162 5.13828 31.9214 5.18115 31.9181H11.537C12.026 31.9188 12.5063 32.0474 12.9303 32.2912C13.3542 32.5349 13.707 32.8854 13.9536 33.3077L16.2253 37.2227C16.2619 37.2861 16.3149 37.3386 16.3786 37.3747C16.4423 37.4109 16.5146 37.4293 16.5878 37.4281C16.6625 37.4294 16.7362 37.4098 16.8003 37.3713C16.8644 37.3329 16.9163 37.2772 16.9503 37.2106L19.2461 33.2835C19.493 32.8632 19.8465 32.5156 20.2709 32.2758C20.6953 32.0361 21.1754 31.9127 21.6628 31.9181H28.6711C28.714 31.9214 28.7571 31.9162 28.798 31.9027C28.8388 31.8893 28.8766 31.868 28.9092 31.8399C28.9417 31.8118 28.9684 31.7776 28.9877 31.7392C29.007 31.7007 29.0185 31.6589 29.0216 31.616V16.5118C29.0185 16.4689 29.007 16.4271 28.9877 16.3887C28.9684 16.3502 28.9417 16.316 28.9092 16.2879C28.8766 16.2599 28.8388 16.2385 28.798 16.2251C28.7571 16.2117 28.714 16.2064 28.6711 16.2097H5.18115Z",
    fill: "url(#paint0_linear_1614_38326)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M43.4984 46.4167C43.178 46.4167 42.8706 46.544 42.644 46.7706C42.4174 46.9972 42.2901 47.3045 42.2901 47.625H15.7068V41.5833C15.7068 41.2629 15.5795 40.9555 15.3529 40.7289C15.1263 40.5023 14.8189 40.375 14.4984 40.375C14.178 40.375 13.8706 40.5023 13.644 40.7289C13.4174 40.9555 13.2901 41.2629 13.2901 41.5833V52.4583C13.2674 53.3953 13.6171 54.3031 14.2627 54.9827C14.9082 55.6622 15.7969 56.058 16.7339 56.0833H41.263C42.2 56.058 43.0886 55.6622 43.7342 54.9827C44.3797 54.3031 44.7295 53.3953 44.7068 52.4583V47.625C44.7068 47.3045 44.5795 46.9972 44.3529 46.7706C44.1263 46.544 43.8189 46.4167 43.4984 46.4167ZM41.263 53.6667H16.7339C16.4457 53.623 16.1831 53.4766 15.9944 53.2546C15.8056 53.0325 15.7035 52.7497 15.7068 52.4583V50.0417H42.2901V52.4583C42.2934 52.7497 42.1913 53.0325 42.0025 53.2546C41.8138 53.4766 41.5512 53.623 41.263 53.6667Z",
    fill: "url(#paint1_linear_1614_38326)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.7167 29.5H19.3333C19.0129 29.5 18.7055 29.3727 18.4789 29.1461C18.2523 28.9195 18.125 28.6121 18.125 28.2917V19.8333C18.125 19.5129 18.2523 19.2055 18.4789 18.9789C18.7055 18.7523 19.0129 18.625 19.3333 18.625H22.7167C23.4207 18.6282 24.095 18.9093 24.5929 19.4071C25.0907 19.905 25.3718 20.5793 25.375 21.2833V26.8417C25.3718 27.5457 25.0907 28.22 24.5929 28.7179C24.095 29.2157 23.4207 29.4968 22.7167 29.5ZM20.5417 27.0833H22.7167C22.7808 27.0833 22.8422 27.0579 22.8876 27.0126C22.9329 26.9672 22.9583 26.9058 22.9583 26.8417V21.2833C22.9583 21.2192 22.9329 21.1578 22.8876 21.1124C22.8422 21.0671 22.7808 21.0417 22.7167 21.0417H20.5417V27.0833Z",
    fill: "url(#paint2_linear_1614_38326)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.7119 28.0276L13.9719 20.2943C13.9403 20.1769 13.8957 20.0635 13.839 19.956C13.604 19.5522 13.2672 19.2172 12.8622 18.9843C12.4572 18.7515 11.9983 18.6289 11.5311 18.6289C11.0639 18.6289 10.605 18.7515 10.2 18.9843C9.795 19.2172 9.45819 19.5522 9.22319 19.956C9.16738 20.0583 9.12668 20.1682 9.10235 20.2822L7.2536 28.0276C7.21459 28.1865 7.20825 28.3517 7.23497 28.5131C7.26169 28.6745 7.32091 28.8288 7.40904 28.9666C7.49716 29.1045 7.61237 29.223 7.74766 29.315C7.88295 29.407 8.03551 29.4705 8.1961 29.5018C8.28432 29.5136 8.37372 29.5136 8.46194 29.5018C8.74126 29.5086 9.01431 29.4184 9.23462 29.2466C9.45493 29.0747 9.60888 28.8319 9.67027 28.5593L10.2624 25.8768H12.679L13.2953 28.5593C13.3658 28.8798 13.5607 29.1591 13.8372 29.3358C14.1136 29.5126 14.449 29.5723 14.7694 29.5018C15.0899 29.4313 15.3692 29.2364 15.546 28.9599C15.7227 28.6834 15.7824 28.3481 15.7119 28.0276ZM10.8786 23.4601L11.4344 21.0435C11.4748 21.0201 11.5207 21.0078 11.5674 21.0078C11.614 21.0078 11.6599 21.0201 11.7003 21.0435L12.244 23.4601H10.8786Z",
    fill: "url(#paint3_linear_1614_38326)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M51.4608 39.506L49.4188 37.476C49.6986 36.8983 49.8263 36.2588 49.7897 35.6179C49.7532 34.9771 49.5536 34.3561 49.21 33.814C48.8663 33.2719 48.3899 32.8264 47.8259 32.52C47.2619 32.2135 46.6289 32.0561 45.9871 32.0627C45.4926 32.0661 45.0037 32.1683 44.5492 32.3634C44.0948 32.5584 43.6839 32.8424 43.3408 33.1985C42.6506 33.9241 42.2731 34.8918 42.2896 35.8931C42.3085 36.889 42.7158 37.8381 43.4246 38.5379C44.1335 39.2377 45.0877 39.6328 46.0837 39.6389C46.6634 39.605 47.2285 39.4442 47.7392 39.1677L49.7692 41.1735C50.0017 41.37 50.2998 41.4714 50.6039 41.4575C50.908 41.4437 51.1957 41.3156 51.4094 41.0988C51.6231 40.882 51.7471 40.5926 51.7566 40.2883C51.7662 39.9841 51.6605 39.6874 51.4608 39.4577V39.506ZM46.0475 37.2223C45.8671 37.2217 45.6887 37.185 45.5227 37.1145C45.3567 37.0439 45.2065 36.9409 45.0808 36.8114C44.9521 36.6904 44.8493 36.5444 44.7787 36.3824C44.7081 36.2204 44.6711 36.0457 44.67 35.8689C44.6703 35.6867 44.7068 35.5064 44.7774 35.3384C44.8479 35.1704 44.951 35.0181 45.0808 34.8902C45.3287 34.6346 45.6674 34.487 46.0233 34.4794C46.3852 34.4814 46.732 34.6244 46.99 34.8781C47.1171 35.0049 47.218 35.1556 47.2868 35.3215C47.3557 35.4874 47.3911 35.6652 47.3911 35.8448C47.3911 36.0244 47.3557 36.2022 47.2868 36.3681C47.218 36.5339 47.1171 36.6846 46.99 36.8114C46.7421 37.067 46.4035 37.2147 46.0475 37.2223Z",
    fill: "url(#paint4_linear_1614_38326)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M51.9609 45.2096H41.0859C40.1245 45.2096 39.2025 44.8277 38.5227 44.1479C37.8429 43.4681 37.4609 42.546 37.4609 41.5846V31.918C37.4609 30.9566 37.8429 30.0345 38.5227 29.3547C39.2025 28.6749 40.1245 28.293 41.0859 28.293H51.9609C52.9223 28.293 53.8444 28.6749 54.5242 29.3547C55.204 30.0345 55.5859 30.9566 55.5859 31.918V41.5846C55.5859 42.546 55.204 43.4681 54.5242 44.1479C53.8444 44.8277 52.9223 45.2096 51.9609 45.2096ZM41.0859 30.7096C40.7655 30.7096 40.4581 30.8369 40.2315 31.0635C40.0049 31.2902 39.8776 31.5975 39.8776 31.918V41.5846C39.8776 41.9051 40.0049 42.2125 40.2315 42.4391C40.4581 42.6657 40.7655 42.793 41.0859 42.793H51.9609C52.2814 42.793 52.5888 42.6657 52.8154 42.4391C53.042 42.2125 53.1693 41.9051 53.1693 41.5846V31.918C53.1693 31.5975 53.042 31.2902 52.8154 31.0635C52.5888 30.8369 52.2814 30.7096 51.9609 30.7096H41.0859Z",
    fill: "url(#paint5_linear_1614_38326)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M41.263 2.91797H16.7339C15.7969 2.94328 14.9082 3.3391 14.2627 4.01863C13.6171 4.69817 13.2674 5.60596 13.2901 6.54297V11.2917C13.2789 11.6122 13.3954 11.924 13.6141 12.1585C13.8328 12.3931 14.1357 12.5311 14.4561 12.5423C14.7766 12.5536 15.0884 12.437 15.323 12.2183C15.5575 11.9997 15.6956 11.6968 15.7068 11.3763H42.2901V25.8763C42.2901 26.1968 42.4174 26.5041 42.644 26.7307C42.8706 26.9573 43.178 27.0846 43.4984 27.0846C43.8189 27.0846 44.1263 26.9573 44.3529 26.7307C44.5795 26.5041 44.7068 26.1968 44.7068 25.8763V6.54297C44.7295 5.60596 44.3797 4.69817 43.7342 4.01863C43.0886 3.3391 42.2 2.94328 41.263 2.91797ZM15.7068 8.95964V6.54297C15.7035 6.25156 15.8056 5.96878 15.9944 5.74673C16.1831 5.52469 16.4457 5.37833 16.7339 5.33464H41.263C41.5512 5.37833 41.8138 5.52469 42.0025 5.74673C42.1913 5.96878 42.2934 6.25156 42.2901 6.54297V8.95964H15.7068Z",
    fill: "url(#paint6_linear_1614_38326)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1614_38326",
    x1: -2.98719,
    y1: 4.16266,
    x2: 53.4903,
    y2: 60.6402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C28D2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#413216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45260F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1614_38326",
    x1: -10.1999,
    y1: 11.375,
    x2: 46.2776,
    y2: 67.8525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C28D2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#413216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45260F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1614_38326",
    x1: -0.785417,
    y1: 1.96208,
    x2: 55.7042,
    y2: 58.4396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C28D2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#413216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45260F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1614_38326",
    x1: -6.29182,
    y1: 7.47387,
    x2: 50.1857,
    y2: 63.9635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C28D2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#413216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45260F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1614_38326",
    x1: 5.67707,
    y1: -4.50146,
    x2: 62.1546,
    y2: 51.9761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFA600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1614_38326",
    x1: 5.47635,
    y1: -4.29578,
    x2: 61.9539,
    y2: 52.1817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C28D2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFA600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1614_38326",
    x1: 10.8976,
    y1: -9.7212,
    x2: 67.3751,
    y2: 46.7684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFA600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlinemarket);
export default __webpack_public_path__ + "static/media/onlinemarket.2bbdd0288d80fe384a31d166baa432bd.svg";
export { ForwardRef as ReactComponent };